import React, { Fragment } from 'react';
import { connect } from 'react-redux';
// import format      from 'date-fns/format';
// import isEqual     from 'date-fns/isEqual';
// import PicGetRequest  from '../apis/PicGetRequest';
import { ExpansionPanel } from './ExpansionPanel';
import { PicInvitationContribTable } from './PicInvitationContribTable';
import { DropDownMenu } from './menus/DropDownMenu';
import { TextButton } from './buttons/TextButton';
import   MessageModal  from './modals/MessageModal';
import { prtStart, prtVar, prtMsg, prtInput } from '../utils/prt';

const FNAME = "PicInvitationContribPanel";
const TRACE = true;

// ***************************************************************************
// Component process
// When component mounts the following occurs:
//   - Make api call to get contributions for event and save in local state
//   - Call function to convert contributions array of objects to an array of an array
//   - This conversion function also copies the quantity needed from cell 1 to cell 4 
//     Cell 1 is used as the original amount needed and Cell 4 keeps track of user input
// In the render():
//   - The Styled Table is displayed dynamically by using contributions saved in local
//     state and getStyledContribTable() function.
// Everytime user changes quantity value the onChange method will: 
//   - update the value in cell 4 of the contributions list in local state.
//   - the render function will re-render table with new value.
// ***************************************************************************

const TopBorder = () => (
    <div className="pic-event-tb"/> 
);

// This a flex table component that takes as props an array of rows (each row has array of column/cells) that 
// allows for a fixed number of columns (eg 3 or 4). Note that the contents of each cell or column in the 
// flex table can be text or jsx. The mapping of the data to the JSX structures is done in the componentDidMount
// lifecycle method.
export class PicInvitationContribPanel extends React.Component { 

    constructor(props) {
        super(props);

        this.state = {
            eventObj: this.props.dataset1 || {},
            headerLabels: ["Item Description", "Qty Needed", "Contribution", ""],
            showMessageModal: false,
            formError: ''
        }
    }

    //*************************************************************************
    // Lifecycle methods
    //*************************************************************************

    /* Initialize event info object and contribution list. It does not change so its ok to save in this
       child component  */
    componentDidMount = () => {
        let eventObj        = this.props.dataset1 || {};
        this.setState({eventObj});
    }

    
    //*************************************************************************
    // Event Handlers
    //*************************************************************************
    /* this handler is used by ErrorMessage Component. When user clicks the X
     it clears the formError value and effectively closes the message box */
    clearErrorMessage = () => {
        this.setState({formError: ''})
    }

    /* This is fired when user clicks caret icon on the expansion panel1 */
    handleOnClickForPanel1 = () => {
        this.props.handleOnClickForPanel();
    } 

    /* This handler only updates the contribution amount in the column 3 of the table for display.*/
    handleOnChangeQuantity = (indexValue, e) => {

        let contributionAmt =  e.target.value || '';
        let contributions   =  this.props.dataset2;

        /* make copy of contributions */
        let copyOfContributions = [...contributions];

        /* update the contribution amount in column 3 of the table for display */
        copyOfContributions[indexValue][2] = contributionAmt;
        
        /* update in parent */
        this.props.handleChangeQuantity(copyOfContributions);
    }

    /* This is fired when user clicks the "Count Me In" button. After validating input, this
       handler will update the contributors list with the participants contribution. Note that 
       the participant is referred to as the contributor in this handler. Also note that the 
       item is marked as updated. This is for purposes of only sending updated items 
       to the API, as opposed to sending entire list. This was later changed to sending the entire list.   */
    handleOnClickContribution = (indexValue) => {
        //TRACE  &&  prtStart(FNAME, "handleOnClickContribution");
        //TRACE  &&  prtInput("indexValue", indexValue);
        
        // /* First and foremost get username and  user-email to be able to track who is participating */
        // /* If user is logged in, use the name of the authorized user */
        // let contributions = this.props.dataset2;

        // let participantName  = this.getParticipantName();
        // let participantEmail = this.getParticipantEmail();

        // if (participantEmail === "none") {
        //     //TRACE &&prtVar("participantEmail", participantEmail); 
        //     // this.setState({showMessageModal: true})
        //     this.props.setParentStateValues({showNameEmailModal: true})
        //     return;
        // }

        // //TRACE &&prtMsg("This partcipant name and email ")
        // //TRACE &&prtVar("participantName", participantName);
        // //TRACE &&prtVar("participantEmail", participantEmail);
        // //TRACE &&prtVar("Parent participantEmail", this.props.getParentStateValue("participantEmail"));
        // //TRACE &&prtVar("Parent participantName", this.props.getParentStateValue("participantName"));

        // /* Set quantity needed and set contribution */
        // let quantityNeeded = contributions[indexValue][1];
        // let contribution =  contributions[indexValue][2]
       
        // /* Check input. If valid, add user to list */
        // if (contribution > quantityNeeded) {
        //     this.handleRaiseError("Note: Quantity exceeded quantity needed. Lower contribution.");
        // } else 
        // if (contribution < 1 && contribution > -1) {
        //     this.handleRaiseError("Note: Contribution cannot be 0.");
        // } else 
        // if (contribution < 0) {
        //     this.handleRaiseError("Note: Contribution cannot be negative value." );
        // } else {
        //  // console.log(`User ${participantName} with email ${participantEmail} is contributing ${contribution}  item`)
        //     let contributionsCopy = [...contributions];
         
        //     /* update contributions list with new Quantity based on contribution amount  */
        //     let newQuantityNeeded = quantityNeeded - contribution;
        //     contributionsCopy[indexValue][1]  = newQuantityNeeded;

        //     /* mark item as updated */
        //     contributionsCopy[indexValue][5]  = "updated";

        //     /* construct contributor object */     
        //     let contributor = {
        //         email: participantEmail,
        //         name:  participantName,
        //         amount: contribution
        //     }
        //     /* Get participants index value in contributor list for the updateContributorList function */
        //     let contributorIndexValue = this.getContributorIndexValue(contributionsCopy, contributor, indexValue);

        //     /* Update the contributor list with the contribution amount. Index value is effectively the table row number */
        //     this.updateContributorsList(contributionsCopy, contributor, indexValue, contributorIndexValue);

        //     // console.log("INDEX VALUE AT HANDLE ON CLICK CONTRIBUTION END ", indexValue);

        //     TRACE && prtMsg("Call handleChangeDataSet2 function on PicInvitation to update contrib list on database")
        //     /* update list on database */            
        //     this.props.handleChangeDataSet2(contributions, indexValue, newQuantityNeeded);
        this.props.handleContribCountMeInButton(indexValue);
        // }
    }

    getContributorIndexValue = (contributionList, contributor, indexValue) => {
        let participantEmail = contributor.email;
        let contributorList  = this.getContributorList(contributionList, indexValue);
        return contributorList.findIndex(contributor => contributor.email === participantEmail);
    }
    updateContributorsList = (contributionList, contributor, indexValue, contributorIndexValue) => {
        /* In contributorIndexValue is -1 then participant is not in contribution list. Add contributor 
           to front of the list. If contributorIndexValue > -1, update in place */
        let contributorList  = this.getContributorList(contributionList, indexValue);
        if (contributorIndexValue === -1) {
            contributorList.unshift(contributor);
        } else 
        if (contributorIndexValue > -1) {
            contributorList[contributorIndexValue] = contributor;
        }
    }

    /* Calls the parent handler used to raise an error */
    handleRaiseError = (text) => {
        this.props.raiseErrorHandler(text);
    }


    /* Handle NameEmail modal     */
    handleCancelMessageModal = () => {
        //TRACE &&prtStart(FNAME, "handleCancelMessageModal");
        this.setState({showMessageModal: false})
    }


    //*************************************************************************
    // Column Header Renderer
    //*************************************************************************

    /* Based on column header, send different classname  */
    getHeaderJsx= (content, classname) => {
        return (
            <div className={`${classname}`}>
                {content}
            </div>
        )
    }

    //*************************************************************************
    // Column Renderers 
    //*************************************************************************

    getTextColumnJsx = (content, justify) => {
        return (
            <div className={`pict-text-column-${justify}`}>
                {content}
            </div>
        )
    }

    getInputColumnJsx = (indexValue) => {
        //TRACE &&prtStart(FNAME, "getInputColumnJsx");
        //TRACE &&prtInput("indexValue", indexValue);

        let contributions = this.props.dataset2;

        let indexedRow = contributions[indexValue];
        let neededQuantity = indexedRow[1]
        let inputQuantity = indexedRow[2];
        
        if (neededQuantity <= 0) { inputQuantity = 0; }

        return (
            <div className="rc-flex-container-center-hv">
                <form onSubmit={this.onSubmit}>
                  <input  className="pict-input-column"
                    type="number"
                    min="1"
                    max={neededQuantity}
                    placeholder="qty"
                    onChange={this.handleOnChangeQuantity.bind(this, indexValue)}  // Handler called to update the state with whats entered in input field
                    value={inputQuantity}         // value to render component with (from value of state updated onChangeHandler
                  />
                </form>
            </div>
        )
    }
   
    getButtonColumnJsx = (indexValue) => {
        return (
            <div className="rc-flex-container-center-hv">
                <button className="pic-event-contribute-button" onClick={this.handleOnClickContribution.bind(this, indexValue)}>
                     Count Me In
                </button>
            </div>
        )
    }

    getDropDownJsx = (indexValue) => {
        let contributions = this.props.dataset2;
        /* construct dropdown list */
        let contributorList = this.getContributorList(contributions, indexValue);

        let ddlist = contributorList.map((contributor, i) => {
            let name   =  this.truncateLastNameIfTooLong(contributor.name);

            return {
                key: i,
                title: `${name} (${contributor.amount}) ` ,
                selected: false,
                listname: 'contributors'
            }
        })

        return (
            <div className="rc-flex-container-center-hv">
                <DropDownMenu title="Names" list={ddlist.concat(this.getTextButton(indexValue))} 
                            altHeaderClass="drop-down-header-nb"  
                            altDDListClass="drop-down-list-alt1"
                            config={{displayHeader: false}} toggleSelected={ () => {;} }
                />
            </div>
        )
    }

    //*************************************************************************
    // Row renderers
    //*************************************************************************

    /* Render Header row for contribution table  (processes each header label) */
    getStyledContribHeader = () => {
        let { headerLabels } = this.state;
        let styledHeader = [];
        headerLabels.forEach((headerLabel, idx) => {
            let classname = "pict-header-label-left";
            if (idx === 0) {classname = "pict-header-label-item"};
            if (idx === 1) {classname = "pict-header-label-needed"};
            if (idx === 2) {classname = "pict-header-label-contrib"};
            let headerJsx = this.getHeaderJsx(headerLabel, classname);
            styledHeader.push(headerJsx)
        })
        return styledHeader;
    }


    /* Render rows for contribution table. Column three intially is the 'Count Me In' button but 
       gets converted to DropDownList when user adds a contribution. This allows them to see the 
       list */
    getStyledContribTable = (contributions) => {
        // let { contributions } = this.state;

        // contributionsCopy[indexValue][3] = this.getDropDownJsx();

        let styledRows = [];
        /* add the header to styledRows */
        styledRows.push(this.getStyledContribHeader());
        /* add the table entries to the styledRows ; note add a +1 to create offset for header row */
        contributions.forEach((row, i) => {
            let itemDescription = row[0];   /* pull column 0 */
            let neededQuantity  = row[1];   /* pull column 1 */
            let contribAmount   = row[2];   /* pull column 2 */

            let styledRow = []
            styledRow[0] = this.getTextColumnJsx(itemDescription, "left");     /* replaces first column with jsx */
            styledRow[1] = this.getTextColumnJsx(+neededQuantity, "center");   /* replaces secnd column with jsx, Note + sign is technique for removing leading zero */
            styledRow[2] = this.getInputColumnJsx(i, neededQuantity);    /* pass in index value and initial qty */
            // styledRow[3] = this.isParticipantContributor(i)  ? this.getDropDownJsx(i) : this.getButtonColumnJsx(i);
            styledRow[3] = this.isParticipantContributor(i) || neededQuantity === 0 ? this.getDropDownJsx(i) : this.getButtonColumnJsx(i);

            styledRows.push(styledRow)
        })
        return styledRows;
    }

    /* getStyledContribTable Helper function/ */
    isParticipantContributor = (rowIndex) => {
        let contributions = this.props.dataset2;
        let participantEmail = this.getParticipantEmail();
     
        let contributorsList = contributions[rowIndex][4];  /* column 4 has the contributors list */
        let indexFound = contributorsList.findIndex(contributor => contributor.email === participantEmail);
        return indexFound === -1 ? false : true;
    }


    //*************************************************************************
    // Utilities / or Help functions
    //*************************************************************************

    /* function to add text button at the end of dropdown list*/
    getTextButton = (indexValue) => {
        /* construct an array with one item to concat to list */
        let textButtonItem = [{
            key: 9999,
            title: <TextButton text="Remove my name" myclassname="text-button-xxsmall" 
                               onClickHandler={this.deleteContributorFromList.bind(this, indexValue, this.getParticipantEmail())} />
        }]
        return textButtonItem;
    }

    /* This deletes contributor from list and also adds back the contribution amount to quantity needed */
    // deleteContributorFromList = (indexValue, participantEmail) => {
    deleteContributorFromList = (indexValue) => {
        //TRACE  && prtStart(FNAME, "deleteContributorFromList"); 

        // if (this.props.mockMode === true) {return};
        
        // let contributions = this.props.dataset2;

        // /* get contributor list for a given item */
        // let contributorList = this.getContributorList(contributions, indexValue);

        // /* find participant in the contributor list and obtain amount participant was contributing. */
        // let foundContributor = contributorList.find((contributor) => { return contributor.email === participantEmail });
        
        // /* If partcipant not found in contributor list and invite was sent by organizer raise error */ 
        // if (!foundContributor && this.props.inviteSentBy === "organizer") {
        //     TRACE && prtMsg("This is an invite from the organizer, but user is trying to delete from drop down list where their name does not appear")
        //     this.handleRaiseError("No Action taken: as your name is not listed as a contributor for this item.");
        //     return;
        // };

        // /* If partcipant not found in contributor list and invite was sent by anonymous then tell the parent
        //    to prompt for Name and Email by setting showNameEmailModal to true. Also close panel so that 
        //    user is forced to rerender list, otherwise everytime uesr clicks remove my name they will keep getting modal */ 
        // if (!foundContributor && this.props.inviteSentBy === "anonymous") {
        //     TRACE && prtMsg("This is an anonymous invite, seems like we do not have the name and email address.")
        //     TRACE && prtMsg("Calling setParentValues to trigger showNameEamilModal ")
        //     this.props.setParentStateValues({showNameEmailModal: true, panel1IconOpen: false})
        //     return;
        // };


        // let amountContributed = foundContributor.amount;

        // /* delete contributor from list */
        // let updatedContributorList  = contributorList.filter((contributor) => contributor.email !== participantEmail);
        // let copyOfContributions = [...contributions];
        // copyOfContributions[indexValue][4] = updatedContributorList;

        // /* get quantityNeeded for the given item (based on indexValue) */
        // let quantityNeeded   = copyOfContributions[indexValue][1]; // get quantity needed
        // // let contributionAmt = copyOfContributions[indexValue][2];  // get contributionAmt

        // /* add contribution amount back to quantity needed */
        // quantityNeeded = parseInt(quantityNeeded, 10) + parseInt(amountContributed,10);
        // // quantityNeeded = parseInt(quantityNeeded, 10) + parseInt(contributionAmt,10);

        // /* set quantity needed to new value */
        // copyOfContributions[indexValue][1] = quantityNeeded;
        // /* set contribution amount back to same as quantity needed */
        // copyOfContributions[indexValue][2] = quantityNeeded;

        // /* mark item as "notUpdated" */
        // copyOfContributions[indexValue][5] = "notUpdated";

        // /* update contribution list in parent */
        // // this.props.handleChangeDataSet2(indexValue);
        this.props.handleRemoveContributor(indexValue);
    }

    /* The following two methods serve as wrappers that hide the implementation details as 
       as how to get participant name and email. How you get it is based on whether your an authenticated user or 
       participant with a token */
    getParticipantName = () => {
        /* if user is logged in, use the name of the authorized user */
        let participantName = "";
        if (this.props.auth.isAuthenticated) {
            participantName = this.props.auth.user.firstname + ' ' + this.props.auth.user.lastname;
        } else if (this.state.eventObj.participantName) {
            participantName = this.state.eventObj.participantName
        } else {
            participantName = this.props.getParentStateValue("participantName");
        }

        return participantName;
    }

    getParticipantEmail = () => {
        /* pull off participantEmail from parent component (PicInvitation) */
        let participantEmail = this.props.getParentStateValue("participantEmail")
        return participantEmail;
    }

    /* Contributor list   is found as 4th item in table row . Created this help function so that
       in event it moves, I only need to change it one place */
    getContributorList = (contributionList, rowIndex) => {
        return contributionList[rowIndex][4];
    }
    
    truncateLastNameIfTooLong = (name) => {
        let maxLength = 13;
        let fullname = name.split(' ');

        return (name.length > maxLength) ? fullname[0] : name;
    }

    //*************************************************************************
    // Component render method
    //*************************************************************************
    render() {
        let contributions = this.props.dataset2;

        let styledContribTable = this.getStyledContribTable(contributions);

        return (
            <div> 
                 <ExpansionPanel onClickHandler={this.handleOnClickForPanel1} text="Contributions" open={this.props.open} />
                 {this.props.open  &&  <PicInvitationContribTable rows={styledContribTable} /> }  
                 <MessageModal 
                    showModal={this.state.showMessageModal} 
                    message='Please click on "Yes" or "No" to let us know if you will be attending.'
                    cancelHandler={this.handleCancelMessageModal}
                 />  
            </div>
        );
    };

    
};

const mapStateToProps = (state) => {
    return {
        auth:  state.auth
    };
};

export default connect(mapStateToProps)(PicInvitationContribPanel);
// export default connect(mapStateToProps, mapDispatchToProps)(PicInvitationPanel1);

/*
onChange={this.handleOnChangeQuantity.bind(this, indexValue) }  // Handler called to update the state with whats entered in input field

<DropDownMenu title="Names" list={ddlist.concat(this.getTextButtonItem())} toggleSelected={ () => {;} } 
                                          config={{displayHeader: false}}/>

*/
 


// WEBPACK FOOTER //
// ./src/components/PicInvitationContribPanel.js